import React from 'react';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import HeaderBack from '../../../components/mobile/HeaderBack';
import PersonalnformationForm from '../../../components/mobile/user-account/PersonalnformationForm';

function MobilePersonalInformationScreen() {
  const { t } = useTranslation(['user-account', 'common']);
  const history = useHistory();

  const onBack = () => {
    history.push('/user-account')
  }

  const onConfirm = () => {
    history.push('/user-account')
  }

  return (
    <>
      <HeaderBack
        onBack={onBack}
        text={t('user-account:personalInformation.previousPage')}
        title={t('user-account:personalInformation.title')}
        subtitle={t('user-account:personalInformation.subtitle')}
      />
      <PersonalnformationForm
        onSubmitForm={onConfirm}
        onSubmitBtnText={t('common:button.confirmSaveChange')}
      />
    </>
  );
}

export default MobilePersonalInformationScreen;
